import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type RenewAppraisalMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  status: Types.Scalars['String']['input'];
  apiVehicle?: Types.InputMaybe<Types.Scalars['jsonb']['input']>;
}>;


export type RenewAppraisalMutation = { __typename?: 'mutation_root', update_appraisals?: { __typename?: 'appraisals_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'appraisals', id: number, status: string, vehicle_data?: object | null }> } | null };


export const RenewAppraisalDocument = gql`
    mutation renewAppraisal($id: bigint!, $status: String!, $apiVehicle: jsonb) {
  update_appraisals(
    where: {id: {_eq: $id}}
    _set: {status: $status, vehicle_data: $apiVehicle, last_fetch_time_utc: "now()"}
  ) {
    affected_rows
    returning {
      id
      status
      vehicle_data
    }
  }
}
    `;
export type RenewAppraisalMutationFn = Apollo.MutationFunction<RenewAppraisalMutation, RenewAppraisalMutationVariables>;

/**
 * __useRenewAppraisalMutation__
 *
 * To run a mutation, you first call `useRenewAppraisalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewAppraisalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewAppraisalMutation, { data, loading, error }] = useRenewAppraisalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      apiVehicle: // value for 'apiVehicle'
 *   },
 * });
 */
export function useRenewAppraisalMutation(baseOptions?: Apollo.MutationHookOptions<RenewAppraisalMutation, RenewAppraisalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewAppraisalMutation, RenewAppraisalMutationVariables>(RenewAppraisalDocument, options);
      }
export type RenewAppraisalMutationHookResult = ReturnType<typeof useRenewAppraisalMutation>;
export type RenewAppraisalMutationResult = Apollo.MutationResult<RenewAppraisalMutation>;
export type RenewAppraisalMutationOptions = Apollo.BaseMutationOptions<RenewAppraisalMutation, RenewAppraisalMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appraisals/queries/renewAppraisal.mutation.gql}
 */
export async function renewAppraisal(
  variables: RenewAppraisalMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RenewAppraisalMutation['update_appraisals']>
export async function renewAppraisal(
  variables: RenewAppraisalMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RenewAppraisalMutation>
export async function renewAppraisal(
  variables: RenewAppraisalMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RenewAppraisalMutation['update_appraisals'] | RenewAppraisalMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RenewAppraisalMutation>(
    RenewAppraisalDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_appraisals
}